<section
  class="flock-field"
  aria-hidden="true"
  [class.is-fallback]="reducedMotion"
  [style.height]="height"
  [style.--scene-speed-input]="speed"
  [style.--scene-intensity-input]="intensity"
>
  <div class="sky"></div>
  <canvas #canvas class="flock-canvas"></canvas>
</section>
